
export enum WeekDays {
    SUNDAY= 'SUNDAY',
    MONDAY= 'MONDAY',
    TUESDAY= 'TUESDAY',
    WEDNESDAY= 'WEDNESDAY',
    THURSDAY= 'THURSDAY',
    FRIDAY= 'FRIDAY',
    SATURDAY= 'SATURDAY'
}

export const weekDays : WeekDays[] = [
    WeekDays.SUNDAY,
    WeekDays.MONDAY,
    WeekDays.TUESDAY,
    WeekDays.WEDNESDAY,
    WeekDays.THURSDAY,
    WeekDays.FRIDAY,
    WeekDays.SATURDAY
]

